<template>
  <div class="page">
    <div class="ctrl">
      <a-form layout="inline">
        <a-form-item>
          <a-input v-model="options.name" placeholder="姓名" />
        </a-form-item>
        <a-form-item>
          <a-input v-model="options.nickname" placeholder="昵称" />
        </a-form-item>
        <a-form-item>
          <a-input v-model="options.tel" placeholder="电话" />
        </a-form-item>
        <a-form-item>
          <a-button icon="search" type="primary" @click="search()"></a-button>

          <a-button style="margin-left: 20px" @click="exportJoin"
            >导出</a-button
          >
        </a-form-item>
      </a-form>
    </div>

    <div class="stat">
      共{{ stat.amount }}条，{{ stat.joinAmount }}人，{{ stat.totalFee }}元
    </div>

    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="nickname" slot-scope="text, record">
        <img height="24px" :src="record.headimgurl" alt="" />
        {{ record.nickname }}
      </template>

      <template slot="form" slot-scope="text, record"
        ><a-button size="small" @click="showForm(record)"
          >查看</a-button
        ></template
      >

      <template slot="pay" slot-scope="text, record">
        <a-tag :color="record.is_pay == 1 ? 'green' : 'red'">{{
          record.is_pay == 1 ? "已支付" : "未支付"
        }}</a-tag>
        <div v-if="record.is_pay == 1">{{ record.payed_at }}</div>
      </template>

      <template slot="status" slot-scope="text, record">
        <a-tag :color="record.status_color">{{ record.status_name }}</a-tag>
      </template>

      <template slot="approver" slot-scope="text, record">
        <div>{{ record.approver }}</div>
        <div>{{ record.approved_at }}</div>
        <div>{{ record.app_remarks }}</div>
      </template>
      <template slot="options" slot-scope="text, record">
        <a-button size="small" type="primary" @click="app(record)"
          >审核</a-button
        >
      </template>
    </a-table>

    <a-pagination
      @change="changePage"
      :total="page.total"
      :defaultPageSize="50"
      :defaultCurrent="page.now_page"
      showQuickJumper
      class="margin15"
    />

    <a-modal
      :visible="joinForm.show"
      title="报名表单"
      @ok="close"
      @cancel="close"
      :width="640"
    >
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
        <a-form-item
          v-for="(item, index) in joinForm.data"
          :key="index"
          :label="item.key"
        >
          {{ item.val }}
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      :visible="appModal.show"
      title="审核"
      @ok="doApp"
      @cancel="appModal.show = false"
      :width="640"
    >
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
        <a-form-item label="姓名">{{ appModal.name }}</a-form-item>
        <a-form-item label="人数">{{ appModal.join_num }}</a-form-item>
        <a-form-item label="费用">{{ appModal.fee }}</a-form-item>
        <a-form-item label="支付">{{
          appModal.is_pay ? "已支付" : "未支付"
        }}</a-form-item>
        <a-form-item label="审核">
          <a-radio-group v-model="appModal.result" @change="selectResult">
            <a-radio :value="-10">删除</a-radio>
            <a-radio :value="-1">拒绝</a-radio>
            <a-radio :value="1">通过</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea
            v-model="appModal.remarks"
            placeholder="备注信息会发送给用户"
            auto-size
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  // {
  //   title: "姓名",
  //   dataIndex: "name",
  // },
  {
    title: "昵称",
    scopedSlots: {
      customRender: "nickname",
    },
  },
  // {
  //   title: "手机",
  //   dataIndex: "tel",
  // },
  {
    title: "报名时间",
    dataIndex: "joined_at",
  },
  {
    title: "人数",
    dataIndex: "join_num",
  },
  // {
  //   title: "报名表单",
  //   scopedSlots: {
  //     customRender: "form",
  //   },
  // },
  {
    title: "报名费",
    dataIndex: "fee",
  },
  {
    title: "支付状态",
    scopedSlots: {
      customRender: "pay",
    },
  },
  {
    title: "审批状态",
    scopedSlots: {
      customRender: "status",
    },
  },
  {
    title: "审核人",
    scopedSlots: {
      customRender: "approver",
    },
  },
  {
    title: "支付单号",
    dataIndex: "out_trade_no",
  },
  {
    title: "审核",
    scopedSlots: {
      customRender: "options",
    },
  },
];

export default {
  data() {
    return {
      columns,
      options: {
        tel: "",
        name: "",
        nickname: "",
        activity_id: null,
      },
      page: {
        total: 0,
        now_page: 1,
      },
      list: [],
      stat: {},
      joinForm: {
        show: false,
        data: {},
      },
      appModal: {
        show: false,
      },
    };
  },
  created() {
    this.options.activity_id = this.$route.query.id;
    this.getList();
  },
  methods: {
    search() {
      this.page.now_page = 1;
      this.getList();
    },
    changePage(e) {
      this.page.now_page = e;
      this.getList();
    },
    selectResult() {
      const result = this.appModal.result;
      if (result == -10) this.appModal.remarks = "报名填写有误，请重新报名";
    },
    async getList() {
      this.options.page = this.page.now_page;
      const r = await this.$axios.get("/activity/join/getList", {
        params: this.options,
      });

      if (r.status != 1) return;
      this.list = r.list;
      this.stat = r.stat;
      this.page.total = r.stat.amount;

      
      let arr = []
      for (let item in this.list[0].data) {
        console.log(item);
        arr.push({
          title: item,
          dataIndex: item,
        });
      }

      this.columns = columns.concat(arr)
    },

    showForm(e) {
      const data = [];
      for (let item in e.data) {
        data.push({
          key: item,
          val: e.data[item],
        });
      }

      this.joinForm = {
        show: true,
        data: data,
      };
    },

    close() {
      this.joinForm = {
        show: false,
        data: {},
      };
    },

    app(item) {
      this.appModal = {
        show: true,
        id: item.id,
        result: 0,
        name: item.name,
        fee: item.fee,
        is_pay: item.is_pay,
        join_num: item.join_num,
        remarks: "",
      };
    },

    async doApp() {
      if (!this.appModal.result) return this.$message.error("请选择审核结果");
      console.log(this.appModal);
      const r = await this.$axios.post("/activity/join/approve", {
        id: this.appModal.id,
        result: this.appModal.result,
        remarks: this.appModal.remarks,
      });

      if (r.status == 1) {
        this.appModal.show = false;
        this.getList();
      }
    },

    async exportJoin() {
      const r = await this.$axios.get(
        "/activity/join/exportJoin?activity_id=" + this.options.activity_id
      );

      if (r.status == 1) window.open(r.url);
    },
  },
};
</script>